import { render, staticRenderFns } from "./MiniUserDetail.vue?vue&type=template&id=46ed0fca&scoped=true&"
import script from "./MiniUserDetail.vue?vue&type=script&lang=js&"
export * from "./MiniUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./MiniUserDetail.vue?vue&type=style&index=0&id=46ed0fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ed0fca",
  null
  
)

export default component.exports